import styles from './InformationBar.module.css';
import { Icon, IconName, Intent } from '@blueprintjs/core';
import { classNames } from '@axo/shared/util/dom';

export const InformationBar = ({
  intent,
  text,
  icon,
}: {
  intent: Intent;
  text: string;
  icon: IconName;
}) => {
  return (
    <div className={classNames(styles.infoBar, styles[intent])}>
      <Icon icon={icon} intent={intent} />
      <span>{text}</span>
    </div>
  );
};
